import React, { useState } from "react";
import { motion } from "framer-motion";
import { Head } from "@inertiajs/react";
import Footer from "../components/Footer";
import FilterBar from "../components/FilterBar";
import MapContainer from "../components/MapContainer";
import Sidebar from "../components/Sidebar";
import { Alert, AlertDescription } from "../components/ui/alert";
import { X } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "@inertiajs/react";

const PracticeAlert = () => {
  const [isOpen, setIsOpen] = useState(true);
  if (!isOpen) return null;
  return (
    <Alert className="fixed top-20 left-4 right-4 md:top-auto md:bottom-4 md:left-4 md:right-auto md:w-96 bg-white shadow-lg z-40 border border-gray-200">
      <div className="flex justify-between items-start">
        <AlertDescription className="text-sm">
          En utilisant ce service, vous acceptez nos{" "}
          <Link href="/cgu" className="text-green-600 hover:underline">conditions générales d'utilisation</Link>.
        </AlertDescription>
        <Button variant="ghost" size="sm" onClick={() => setIsOpen(false)} className="h-6 w-6 p-0">
          <X className="h-4 w-4" />
        </Button>
      </div>
    </Alert>
  );
};

interface Physio {
  id: string;
  firstName: string;
  lastName: string;
  address: string;
  city: string;
  lat: number;
  lng: number;
  specialties: string[];
  isCertified: boolean;
  phone: string;
  profileType: "basic" | "filled" | "certified";
  distance?: number | null;
}

interface SearchMetadata {
  expanded?: boolean;
  radius_km?: number;
  original_query?: string;
  filters_relaxed?: boolean;
  message?: string;
  coordinates?: [number, number];
}

interface SearchPageProps {
  physios: Physio[];
  filters?: {
    name?: string;
    city?: string;
    specialties?: string[];
  };
  searchMetadata?: SearchMetadata;
}

export default function SearchPage({ physios = [], filters = {}, searchMetadata }: SearchPageProps) {
  return (
    <>
      <Head title="Recherche de kinésithérapeutes" />
      <div className="flex flex-col h-screen overflow-hidden">
        <FilterBar initialFilters={filters} />
        <motion.div
          className="flex-1 grid lg:grid-cols-[3fr_2fr] overflow-hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          style={{ height: "calc(100vh - 75px)" }}
        >
          <MapContainer physios={physios || []} cityFilter={filters?.city} searchCoordinates={searchMetadata?.coordinates} />
          <Sidebar physios={physios || []} searchMetadata={searchMetadata} />
        </motion.div>
        <PracticeAlert />
      </div>
    </>
  );
} 
